import type { ContextData } from '@common/defaults/ContextData';
import type { ThemeID } from '@common/types/ThemeID';

import manifest from './manifest.json';

const getAssetsPrefix = (contextData: ContextData | undefined): string => {
    let assetsPrefix = process.env['NEXT_PUBLIC_ASSET_PREFIX'];

    if (contextData?.hostname.match(/admin/)) {
        const schema = contextData.hostname.match(/local/) ? 'http' : 'https';
        assetsPrefix = `${schema}://${contextData.context.url}`;
    }

    return assetsPrefix || '';
};

interface Props {
    contextData: ContextData | undefined;
    themeID: ThemeID;
}

export const ThemeVariables = ({ contextData, themeID }: Props) => {
    const assetsPrefix = getAssetsPrefix(contextData);
    const filename = manifest[themeID];
    const href = `${assetsPrefix}/assets/css/${filename}`;
    return <link rel="stylesheet" href={href} />;
};
